import { automaticApi } from "../../../settings/api";
import { clearString } from "../../../utils/functions";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import getStates from "./state";

export interface Fetch {
    zipcode: string;
    callback: (success: boolean, code?: string) => void;
}

export interface SearchAddressAction {
    type: string;
    payload: Fetch;
}

export default function* searchAddressByZipcodeAutomatic({
    payload,
}: SearchAddressAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data = {
            cep: clearString(payload.zipcode),
        };

        const response = yield call(automaticApi.post, `/dominios/v1/endereco/endereco-cep`, data);
        const responseData = response?.data;

        if (responseData.serviceMessage?.codigoRetorno === 0) {
            const states: unknown = yield call(getStates);
            // @ts-expect-error sagas types
            const state = states?.find(
                // @ts-expect-error sagas types
                (state) => state?.codigo === responseData?.dadosEndereco?.codigoEstado,
            );

            responseData.dadosEndereco.uf = state?.sigla;

            yield call(payload.callback, true, responseData.dadosEndereco);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}